import type { ReactNode } from "react";

interface StatCardProps {
  label: string;
  value: string;
  subtext?: string;
  icon?: ReactNode;
  /** Small control (e.g. a reset button) shown in the header row, in place of the icon. */
  action?: ReactNode;
  tone?: "default" | "positive" | "negative" | "warning";
}

const toneClasses: Record<NonNullable<StatCardProps["tone"]>, string> = {
  default: "text-slate-100",
  positive: "text-emerald-400",
  negative: "text-rose-400",
  warning: "text-amber-400",
};

export function StatCard({ label, value, subtext, icon, action, tone = "default" }: StatCardProps) {
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 shadow-sm transition-colors hover:border-slate-700">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-slate-400">{label}</span>
        {action ?? (icon && <span className="text-slate-500">{icon}</span>)}
      </div>
      <div className={`mt-2 text-2xl font-semibold tabular-nums ${toneClasses[tone]}`}>{value}</div>
      {subtext && <div className="mt-1 text-xs text-slate-500">{subtext}</div>}
    </div>
  );
}
